import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '@src/app/services/authentication.service';
import { ENVIRONMENT } from '@src/app/providers/providers';

export const MainGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const isLocalhost: boolean = inject(ENVIRONMENT).isLocalhost;

  if (authService.isAuthenticated() || isLocalhost) {
    return true;
  }

  router.navigate(['auth']);
  return false;
};
